export const setStoreNameState = (state, action): any => {
  const updatedState = {
    ...state,
    isStoreName: action.payload.isStoreName,
  };

  return updatedState;
};
